import '../../assets/styles/globals.scss';
import '../../assets/styles/typography.css';
import { useLocation } from 'react-router-dom';
import { Header } from '../LeftPanel/Header/index';
import { VariablesContent } from '../LeftPanel/VariablesContent/index';
import { useMemo } from 'react';
import Footer from '../LeftPanel/Footer/index';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { Alert } from 'packages/radiant-react/alert';
import { ResizableWrapper } from '../UI/ResizableWrapper/index';
import styles from './styles.module.scss';
import { LoaderGlobal } from 'packages/radiant-react/loading-indicator';
import { route } from 'routes';
import { isAiMode } from '../../utils/variablesService';
import { useAppContext } from 'context/AppContext';
import Chat from 'components/AiMode/Chat';
import MessageInfoPopUp from 'components/AiMode/Chat/MessageInfoPopUp';

function HomePage() {
  const location = useLocation();
  const {
    isHeaderLoading,
    setIsHeaderLoading,
    embedSelections,
    onEmbedSelectionChange,
    goBack,
    setEmbedSelections,
    toastMessageProps,
    setMessageHandler,
    openDownloadModal,
    openPasteModal,
    DownloadModal,
    PasteModal,
    isAiModeActive,
    isStreaming,
  } = useAppContext();

  const routeComponent = useMemo(() => {
    return route(location.pathname, embedSelections, setEmbedSelections);
  }, [location.pathname, embedSelections, setEmbedSelections]);

  return (
    <Horizontal>
      <ResizableWrapper
        className={`theme-builder-wrapper ${isAiMode() ? 'theme-builder-wrapper-ai-mode' : ''}`}
        maxWidth="50%"
      >
        {isAiModeActive ? (
          <Chat />
        ) : (
          <Vertical
            className={`${styles['leftPanelWrapper']} ${
              isAiMode() ? styles['leftPanelWrapper-ai-mode'] : ''
            }`}
          >
            {!isAiMode() && (
              <Header
                isLoading={isHeaderLoading}
                setIsLoading={setIsHeaderLoading}
                selectedPinboard={embedSelections.pinboard}
                selectedViz={embedSelections.viz}
                selectedDataSource={embedSelections.dataSource}
                selectedAnswer={embedSelections.answerId}
                selectedFullApp={embedSelections.pageId}
                onEmbedSelectionChange={onEmbedSelectionChange}
                onBackClick={goBack}
              />
            )}
            <VariablesContent />
            {!isAiMode() && (
              <Footer
                openDownloadModal={openDownloadModal}
                openPasteModal={openPasteModal}
                setMessage={setMessageHandler}
              />
            )}
          </Vertical>
        )}
      </ResizableWrapper>
      <div className={`content-wrapper ${isAiMode() ? 'content-wrapper-ai-mode' : ''}`}>
        {(isHeaderLoading || isStreaming) && (
          <div className="loader-wrapper">
            <LoaderGlobal className="loader-global-home">
              <></>
            </LoaderGlobal>
          </div>
        )}
        {!isHeaderLoading && routeComponent}
      </div>

      <Alert.Toast message={toastMessageProps.message} isVisible={toastMessageProps.isVisible} />
      <PasteModal setMessageHandler={setMessageHandler} />
      <DownloadModal setMessageHandler={setMessageHandler} />
      <MessageInfoPopUp />
    </Horizontal>
  );
}

export default HomePage;
